import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["cell", "summary", "row", "hideEmptyCheckbox"]

  connect() {
    this.updateSummary()
    this.toggleEmptyRows()
  }

  rowTargetConnected() {
    this.toggleEmptyRows()
  }

  updateSummary() {
    let total = 0

    this.cellTargets.forEach(cell => {
      const input = cell.querySelector(".work-man-hours")
      const value = parseFloat(input?.value || 0)
      total += value
    })

    if (this.hasSummaryTarget) {
      this.summaryTarget.textContent = total.toFixed(2)
    }
  }

  toggleEmptyRows() {
    const hideEmpty = this.hasHideEmptyCheckboxTarget ? this.hideEmptyCheckboxTarget.checked : true

    this.rowTargets.forEach(row => {
      if (row.dataset.empty === "true") {
        row.style.display = hideEmpty ? "none" : ""
      } else {
        row.style.display = ""
      }
    })
  }
}